const randCodeSet = new Set<string>();
const rand = {
    code: (prefix = '', postfix = '', n = 8): string => {
        // n자리 난수 키 생성
        var key = '';
        for (var i = 0; i < n; i++) {
            key += rand.minmax(0, 9);
        }
        key = prefix + key + postfix;
        if (randCodeSet.has(key)) {
            return rand.code(prefix, postfix, n);
        } else {
            randCodeSet.add(key);
        }
        return key;
    },
    minmax: (min: number, max: number): number => {
        // min ~ max 난수 생성
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
};
const str = {
    padding: (n: number, digit: number, pad: string, dir: 'left' | 'right' = 'left'): string => {
        let result = n.toString();
        const pCount = digit - result.toString().length;
        if (pCount > 0) {
            const p = pad.substring(0, 1);
            for (let i = 0; i < pCount; i++) {
                if (dir == 'left') {
                    result = p + result;
                } else {
                    result += p;
                }
            }
        }
        return result;
    },
    arrayToStr: (arr: any[], sep: string = ',') => {
        if (arr.length > 0) {
            const sSet = new Set(); // 중복 제거
            arr.map((item) => {
                if (item != undefined && item != null) {
                    sSet.add(item.toString());
                }
            });
            return Array.from(sSet).join(sep);
        }
        return '';
    },

    maxLength: (str?: string, max: number = 50, ellipsis: string = '') => {
        if (str == undefined || str == null) return '';
        return str.length <= max ? str : str.substring(0, max) + ellipsis;
    },
};

const stripHtmlTags = (html: string) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
};

const isDev = import.meta.env.NODE_ENV === 'development';

const formatDateString = (dateString: string) => {
    if (!dateString) {
        return '';
    }
    return dateString.slice(2);
};

export default {
    str,
    rand,
    stripHtmlTags,
    log: isDev ? console.log : (...data: any[]) => {},
    formatDateString,
};
